import Vue from "vue";
import Vuex from "vuex";
import commonModule from "./modules/common";
import authModule from "./modules/auth";
import initCommonData from "./plugins/initCommon";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        common: commonModule,
        auth: authModule,
    },
    plugins: [initCommonData],
});
